// import React from 'react';
import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { ApiUrl } from '../Constants/Weburl'
import useExpandableRows from './useExpandableRows';
import useHiddenColumns from './useHiddenFields';
import CustomTable from './CustomTable';


export default function Poststories() {

  const [users, setUsers] = useState([]);
  const [userstories , setUserstories] = useState([]);
  const [stories, setStories] = useState([]);
  const [activeTab, setActiveTab] = useState('posts');
     const [viewPost, setViewPost] = useState(null);
        const [isViewModalOpen, setIsViewModalOpen] = useState(false);

         const [viewPosts, setViewPosts] = useState(null);
        const [isViewModalOpens, setIsViewModalOpens] = useState(false);

  const navigate = useNavigate();

  const { id } = useParams();

  // console.log("id users", id);

  const { toggleExpand, isExpanded } = useExpandableRows();


  const postHeaders = [
  { label: "Content", className: "pv-col-content" },
  { label: "Type", className: "pv-col-type", field: "type" },
  { label: "Description & Stats", className: "pv-col-desc", field: "desc" },
  { label: "Created Date", className: "pv-col-date", field: "date" },
  { label: "Action", className: "pv-col-action", field: "action" },
];

const storyHeaders = [
  { label: "Story", className: "pv-col-story" },
  { label: "Type", className: "pv-col-story-type", field: "type" },
  { label: "Created At", className: "pv-col-story-date", field: "date" },
  { label: "Action", className: "pv-col-story-action", field: "action" },
];

const currentHeaders = activeTab === "posts" ? postHeaders : storyHeaders;
const hiddenFields = useHiddenColumns(".pv-table", currentHeaders);


  useEffect(() => {
    fetchSpecificusers();
    fetchStoriesusers();
    admindeletestories();
  }, [id])

  const fetchSpecificusers = async () => {
    try {
      const token = localStorage.getItem("adminToken");

      const res = await axios.get(
        `${ApiUrl}api/auth/adminalluseruploads/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("specific user post stories response", res.data.data);
      setUsers(res.data.data.rows);

    }
    catch (e) {
      console.log("error", e);
    }
  };

  const admindeletePost = async (id) => {
    try {
      const token = localStorage.getItem("adminToken");

      const res = await axios.delete(
        `${ApiUrl}api/auth/admindeletepost/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      console.log("res admindeletepost", res.data)

      setUsers(prev => prev.filter(p => p.id !== id));

    } catch (error) {
      console.error("Delete post failed", error);
    }
  };


  //getstory api 
  const fetchStoriesusers = async () => {
    try {
      const token = localStorage.getItem("adminToken");

      const res = await axios.get(
        `${ApiUrl}api/auth/specificusers/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("specific story user stories response", res.data.data.userstories);
      setStories(res.data.data.userstories);
    }
    catch (e) {
      console.log("error", e);
    }
  };


   const handleStoriesContent = (post) => {
    setViewPost(post);
    setIsViewModalOpen(true);
  };


    const handlePostContent = (post) => {
    setViewPosts(post);
    setIsViewModalOpens(true);
  };


  
  const admindeletestories = async (id) => {
    try {
      const token = localStorage.getItem("adminToken");

      const res = await axios.delete(
        `${ApiUrl}api/auth/deleteadminstories/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      console.log("res admindeleteastories", res.data)

      setStories(prev => prev.filter(p => p.id !== id));

    } catch (error) {
      console.error("Delete stories failed", error);
    }
  };


  return (


    <div className="pv-card">
 
      <div className='storiesbutton'>
        <button
          className={activeTab === "posts" ? "Postsbuttonactive" : "Postsbuttonunactive"}
          onClick={() => {
            setActiveTab("posts");
          }}
        >
          Posts
        </button>
        <button
          className={activeTab === "stories" ? "Postsbuttonactive" : "Postsbuttonunactive"}
          onClick={() => {
            setActiveTab("stories");
          }}
        >
          Stories
        </button>
      </div>

      
      <div className="pv-table-controls">
    
        <div className="rr-left">
          Show
          <select
            className="rr-select"
      
          >
            <option>5</option>
            <option>10</option>
            <option>25</option>
            <option>50</option>
          </select>
          entries
        </div>
        
        {activeTab === 'posts' && (
        <div className="rr-right">
          <span>Search:</span>
          <input
            className="rr-search"
            type="text"

            placeholder="Search Users"
          />
        </div>
        )}
      </div>
      {/* </div> */}

      {/* <table className="pv-table">
        {activeTab === 'posts' && (
          <thead>
            <tr>
              <th>Content</th>
              <th>Type</th>
              <th>Description & Stats	</th>
              <th>Created Date</th>
              <th>Action</th>
            </tr>
          </thead>
        )}

        {activeTab === 'stories' && (
          <thead>
            <tr>
              <th>Story</th>
              <th>Type</th>
              <th>Created At</th>
              <th>Action</th>
            </tr>
          </thead>
        )}



        <tbody>
          {activeTab === 'posts' && (
            <>
              {users?.map((item, idx) => (
                console.log("users" , item.id),               
                 <tr className="rr-actionshastag" key={idx}>

                  <td>
                    <button
                      className="view-btn"
                      onClick={() => handlePostContent(item)}
                    >
                      <i className="bi bi-play" style={{ fontSize: '20px' }}></i> View Content
                    </button>
                  </td>
                  <td className="rr-actions2">{item.postType}</td>


                  <td className="rr-actions4">

                    <div className="likecommentsposts">

                      <div className="likecommentsdesign">

                        <span className="allspan">
                          <i class="bi bi-suit-heart" ></i><span>:</span>{item.like_posts.length}</span>

                      </div>

                      <div className="likecommentsdesign">

                        <span className="allspan">
                          <i class="bi bi-chat"></i>
                          <span>:</span>
                          {item.comments.length}
                        </span>

                      </div>

                      <div className="likecommentsdesign">

                        <span className="allspan"><i class="bi bi-bookmark"></i><span>:</span>{item.save_posts.length}</span>

                      </div>
                      <div className="likecommentsdesign">

                        <span className="allspan"><i class="bi bi-share"></i><span>:</span>{item.share_posts.length}</span>

                      </div>
                    </div>

                    <p className="alldescriptiontext">{item.description}</p>
                  </td>



                  <td className="rr-actions5">{new Date(item.createdAt).toLocaleDateString("en-IN")}</td>
                  <td className="rr-actionsbutton">
                    <button
                      className="rr-icon-btn green"
                      onClick={() => navigate(`/PostView/${item.id}`)}
                    >
                      <i class="bi bi-eye"></i>
                    </button>

                    <button
                      className="rr-icon-btn red"
                      onClick={() => admindeletePost(item.id)}
                    >
                      <i className="bi bi-trash"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </>
          )}


        </tbody>


        <tbody>
          {activeTab === 'stories' && (
            <>
              {stories?.map((item, idx) => (
                <tr className="rr-actionshastag" key={idx}>

                  <td>
                    <button
                      className="view-btn"
                        onClick={() => handleStoriesContent(item)}
                    >
                      <i className="bi bi-play" style={{ fontSize: '20px' }}></i> View Content
                    </button>
                  </td>
                  <td className="rr-actions2">{item.filestype}</td>






                  <td className="rr-actions5">{new Date(item.createdAt).toLocaleDateString("en-IN")}</td>
                  <td className="rr-actionsbutton">

                   
                   

                    <button
                      className="rr-icon-btn red"
                      onClick={() => admindeletestories(item.id)}
                    >
                      <i className="bi bi-trash"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </>
          )}


        </tbody>



      </table> */}

      <CustomTable headers={currentHeaders} className="pv-table">
  {activeTab === 'posts' && (
    <>
      {users?.map((item, idx) => (
        <React.Fragment key={item.id ?? idx}>
          <tr className="rr-actionshastag">
            <td style={{display: 'flex' , alignItems:'center'}}>
              {hiddenFields.length > 0 && (
                <button
                  type="button"
                  className={`row-expand-toggle ${isExpanded(item.id ?? idx) ? "is-open" : ""}`}
                  onClick={() => toggleExpand(item.id ?? idx)}
                  aria-label="Show more details"
                >
                  {isExpanded(item.id ?? idx) ? "−" : "+"}
                </button>
              )}
              <button
                className="view-btn"
                onClick={() => handlePostContent(item)}
              >
                <i className="bi bi-play" style={{ fontSize: '20px' }}></i> View Content
              </button>
            </td>
            <td className="pv-col-type">
              <span className='real-badge'>{item.postType}</span></td>

            <td className="rr-actions4 pv-col-desc">
              <div className="likecommentsposts">
                <div className="likecommentsdesign">
                  <span className="allspan">
                    <i className="bi bi-suit-heart"></i><span>:</span>{item.like_posts.length}
                  </span>
                </div>
                <div className="likecommentsdesign">
                  <span className="allspan">
                    <i className="bi bi-chat"></i><span>:</span>{item.comments.length}
                  </span>
                </div>
                <div className="likecommentsdesign">
                  <span className="allspan"><i className="bi bi-bookmark"></i><span>:</span>{item.save_posts.length}</span>
                </div>
                <div className="likecommentsdesign">
                  <span className="allspan"><i className="bi bi-share"></i><span>:</span>{item.share_posts.length}</span>
                </div>
              </div>
              <p className="alldescriptiontext">{item.description}</p>
            </td>

            <td className="rr-actions5 pv-col-date">{new Date(item.createdAt).toLocaleDateString("en-IN")}</td>
            <td className="rr-actionsbutton pv-col-action">
              <button className="rr-icon-btn green" onClick={() => navigate(`/PostView/${item.id}`)}>
                <i className="bi bi-eye"></i>
              </button>
              <button className="rr-icon-btn red" onClick={() => admindeletePost(item.id)}>
                <i className="bi bi-trash"></i>
              </button>
            </td>
          </tr>

          {isExpanded(item.id ?? idx) && hiddenFields.length > 0 && (
            <tr className="row-expand-details">
              <td colSpan={5}>
                <div className="expand-details">
                  {hiddenFields.map(({ field, label }) => (
                    <div className="expand-item" key={field}>
                      <span className="expand-label">{label}</span>

                      {field === "type" && (
                        <span className="real-badge">{item.postType}</span>
                      )}

                      {field === "desc" && (
                        <div>
                          <div className="likecommentsposts">
                            <div className="likecommentsdesign">
                              <span className="allspan"><i className="bi bi-suit-heart"></i><span>:</span>{item.like_posts.length}</span>
                            </div>
                            <div className="likecommentsdesign">
                              <span className="allspan"><i className="bi bi-chat"></i><span>:</span>{item.comments.length}</span>
                            </div>
                            <div className="likecommentsdesign">
                              <span className="allspan"><i className="bi bi-bookmark"></i><span>:</span>{item.save_posts.length}</span>
                            </div>
                            <div className="likecommentsdesign">
                              <span className="allspan"><i className="bi bi-share"></i><span>:</span>{item.share_posts.length}</span>
                            </div>
                          </div>
                          <p className="alldescriptiontext" style={{ margin: "8px 0 0" }}>{item.description}</p>
                        </div>
                      )}

                      {field === "date" && (
                        <span className="expand-value">
                          {new Date(item.createdAt).toLocaleDateString("en-IN")}
                        </span>
                      )}

                      {field === "action" && (
                        <div style={{ display: "flex", gap: 8 }}>
                          <button className="rr-icon-btn green" onClick={() => navigate(`/PostView/${item.id}`)}>
                            <i className="bi bi-eye"></i>
                          </button>
                          <button className="rr-icon-btn red" onClick={() => admindeletePost(item.id)}>
                            <i className="bi bi-trash"></i>
                          </button>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </td>
            </tr>
          )}
        </React.Fragment>
      ))}
    </>
  )}

  {activeTab === 'stories' && (
    <>
      {stories?.map((item, idx) => (
        <React.Fragment key={item.id ?? idx}>
          <tr className="rr-actionshastag">
            <td className="pv-col-story">
              {hiddenFields.length > 0 && (
                <button
                  type="button"
                  className={`row-expand-toggle ${isExpanded(item.id ?? idx) ? "is-open" : ""}`}
                  onClick={() => toggleExpand(item.id ?? idx)}
                  aria-label="Show more details"
                >
                  {isExpanded(item.id ?? idx) ? "−" : "+"}
                </button>
              )}
              <button
                className="view-btn"
                onClick={() => handleStoriesContent(item)}
              >
                <i className="bi bi-play" style={{ fontSize: '20px' }}></i> View Content
              </button>
            </td>
            <td className="rr-actions2 pv-col-story-type">{item.filestype}</td>
            <td className="rr-actions5 pv-col-story-date">{new Date(item.createdAt).toLocaleDateString("en-IN")}</td>
            <td className="rr-actionsbutton pv-col-story-action">
              <button className="rr-icon-btn red" onClick={() => admindeletestories(item.id)}>
                <i className="bi bi-trash"></i>
              </button>
            </td>
          </tr>

          {isExpanded(item.id ?? idx) && hiddenFields.length > 0 && (
            <tr className="row-expand-details">
              <td colSpan={4}>
                <div className="expand-details">
                  {hiddenFields.map(({ field, label }) => (
                    <div className="expand-item" key={field}>
                      <span className="expand-label">{label}</span>

                      {field === "type" && (
                        <span className="expand-value">{item.filestype}</span>
                      )}

                      {field === "date" && (
                        <span className="expand-value">
                          {new Date(item.createdAt).toLocaleDateString("en-IN")}
                        </span>
                      )}

                      {field === "action" && (
                        <button className="rr-icon-btn red" onClick={() => admindeletestories(item.id)}>
                          <i className="bi bi-trash"></i>
                        </button>
                      )}
                    </div>
                  ))}
                </div>
              </td>
            </tr>
          )}
        </React.Fragment>
      ))}
    </>
  )}
</CustomTable>

          {isViewModalOpen && viewPost && (
  <div className="modal-overlay">
    <div className="modal-box">
      <div>
        <button
          className="close-btn"
          onClick={() => setIsViewModalOpen(false)}
        >
          ✕
        </button>

        <h3 style={{ marginTop: "-5px" }}>View Content</h3>
      </div>

      {viewPost.text && <p>{viewPost.text}</p>}

      <h3>
        {viewPost.hashtags
          ? JSON.parse(viewPost.hashtags).map((tag) => `#${tag}`).join(" ")
          : ""}
      </h3>

      {viewPost.mentions && (
        <p>
          {JSON.parse(viewPost.mentions).map((m) => `@${m}`).join(" ")}
        </p>
      )}

      {/* ---- POST CONTENT (SWIPER) ---- */}
      <div className="content-preview" style={{ width: "100%" }}>
        {(() => {
          if (!viewPost.files) return <p>No media</p>;

          const files = JSON.parse(viewPost.files);

          return (
            <Swiper spaceBetween={10} slidesPerView={1}  modules={[Pagination, Scrollbar, A11y]}
      navigation
      pagination={{ clickable: true }}
      scrollbar={{ draggable: true }}
      onSwiper={(swiper) => console.log(swiper)} 
      onSlideChange={() => console.log('slide change')}

      >

        
              {files.map((file, index) => {
                const fileUrl = `${ApiUrl}${file.replace(
                  /\\/g,
                  "/"
                )}`;

                return (
                  <SwiperSlide key={index}>
                    {file ? (
                      <img
                        src={fileUrl}
                        style={{
                          width: "100%",
                          height: "400px",
                          objectFit: "cover",
                          borderRadius: 10,
                        }}
                      />
                    ) : file.type?.includes("video") ? (
                      <video
                        src={fileUrl}
                        controls
                        style={{
                          width: "100%",
                          height: "400px",
                          objectFit: "contain",
                          borderRadius: 10,
                        }}
                      />
                    ) : null}
                  </SwiperSlide>
                );
              })}
            </Swiper>
          );
        })()}
      </div>
    </div>
  </div>
)}



{/* //post */}
 {isViewModalOpens && viewPosts && (
  <div className="modal-overlay">
    <div className="modal-box">
      <div>
        <button
          className="close-btn"
          onClick={() => setIsViewModalOpens(false)}
        >
          ✕
        </button>

        <h3 style={{ marginTop: "-5px" }}>View Content</h3>
      </div>

      {viewPosts.text && <p>{viewPosts.text}</p>}

      <h3>
        {viewPosts.hashtags
          ? JSON.parse(viewPosts.hashtags).map((tag) => `#${tag}`).join(" ")
          : ""}
      </h3>

      {viewPosts.mentions && (
        <p>
          {JSON.parse(viewPosts.mentions).map((m) => `@${m}`).join(" ")}
        </p>
      )}

      {/* ---- POST CONTENT (SWIPER) ---- */}
      <div className="content-preview" style={{ width: "100%" }}>
        {(() => {
          if (!viewPosts.files) return <p>No media</p>;

          const files = JSON.parse(viewPosts.files);

          return (
            <Swiper spaceBetween={10} slidesPerView={1}  modules={[Pagination, Scrollbar, A11y]}
      navigation
      pagination={{ clickable: true }}
      scrollbar={{ draggable: true }}
      onSwiper={(swiper) => console.log(swiper)} 
      onSlideChange={() => console.log('slide change')}

      >

        
              {files.map((file, index) => {
                const fileUrl = `${ApiUrl}${file.uri.replace(
                  /\\/g,
                  "/"
                )}`;

                return (
                  <SwiperSlide key={index}>
                    {file ? (
                      <img
                        src={fileUrl}
                        style={{
                          width: "100%",
                          height: "400px",
                          objectFit: "cover",
                          borderRadius: 10,
                        }}
                      />
                    ) : file.type?.includes("video") ? (
                      <video
                        src={fileUrl}
                        controls
                        style={{
                          width: "100%",
                          height: "400px",
                          objectFit: "contain",
                          borderRadius: 10,
                        }}
                      />
                    ) : null}
                  </SwiperSlide>
                );
              })}
            </Swiper>
          );
        })()}
      </div>
    </div>
  </div>
)}
    </div>

  );
}
